module.exports = __webpack_public_path__ + "static/media/11-mob.5d72748b.png";